app.service('serviceInfoModal', function (modal, productCardManager) {

	function show(props) {

		const {content, onChange} = props;

		const modalInstance = modal.generate({
			id: 'service-modal',
			content,
			cssClass: 'service-modal',
			callbackOpen() {
				this.$modal.on('change', '.js-add-service-checkbox', e => {
					handleAddServiceClick(e.currentTarget, onChange);
					this.close();
				});
			}
		});

		modalInstance.$modal.on('opened', function () {
			modalInstance.$modal.find('.js-add-service-checkbox')
				.filter((i, checkbox) => productCardManager.hasService(parseInt(checkbox.value)))
				.each((i, checkbox) => checkbox.checked = true);
		});

		return modalInstance;
	}

	function handleAddServiceClick(service, onChange) {
		const serviceId = parseInt(service.value);
		if (service.checked) {
			productCardManager.addService(serviceId);
		} else {
			productCardManager.removeService(serviceId);
		}
		onChange(serviceId);
	}

	return {
		show
	};
});